import { ActionFunctionArgs, MetaFunction, redirect } from '@vercel/remix';
import { UserSession } from '~/.server/user-session';
import { AuthLayout } from '../_auth/layout';

export const meta: MetaFunction = () => {
  return [{ title: 'Sign Up | Paragonix' }];
};

export const action = async ({ request }: ActionFunctionArgs) => {
  const form = await request.formData();
  const token = form.get('token');

  if (!token || typeof token !== 'string') {
    return redirect('/sign-in');
  }

  return UserSession.create(token, request.headers.get('Cookie') ?? undefined, '/account-setup');
};

export default function Route() {
  const { onSubmit, error } = AuthLayout.useSignUpFormSubmit();

  return (
    <>
      <AuthLayout.Header>
        <AuthLayout.Title>Sign up</AuthLayout.Title>
        <AuthLayout.Description>
          Already have an account? <a href="/sign-in">Sign In</a>
        </AuthLayout.Description>
      </AuthLayout.Header>

      <AuthLayout.FormContainer>
        <AuthLayout.SignUpForm error={error} onSubmit={onSubmit} />
      </AuthLayout.FormContainer>
    </>
  );
}
